<div aria-live="polite" role="alert">
  <div class="alert" [ngClass]="class(message.severity)" *ngFor="let message of messages()">
    {{ message.value }}
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="dismiss(message)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
